// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"89b81e36","703":"bdc404b7","787":"9c8c0eba"}[chunkId] + ".chunk.js";
};